import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import myImg from "../../Assets/pp.jpeg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiUpwork } from "react-icons/si";
import AnimatedSection from "../AnimatedSection";
import { UPWORK_PROFILE } from "../../constants/links";

const socialLinks = [
  { href: UPWORK_PROFILE, icon: <SiUpwork />, label: "Upwork" },
  { href: "https://github.com/aaftabali1", icon: <AiFillGithub /> },
  { href: "https://twitter.com/theaftabali", icon: <AiOutlineTwitter /> },
  { href: "https://www.linkedin.com/in/theaftabali/", icon: <FaLinkedinIn /> },
  { href: "https://www.instagram.com/theaftabali", icon: <AiFillInstagram /> },
];

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="align-items-center">
          <Col md={8} className="home-about-description">
            <AnimatedSection>
              <h1 className="section-title">
                LET ME <span className="purple">INTRODUCE</span> MYSELF
              </h1>
              <p className="home-about-body">
                I fell in love with programming and I have at least learnt
                something, I think… 🤷‍♂️
                <br />
                <br />
                I am fluent in classics like{" "}
                <b>Javascript, C++ and Java.</b>
                <br />
                <br />
                My field of Interest's are building new{" "}
                <b>Web/Mobile Technologies and Products</b> and also in areas
                related to <b>Blockchain.</b>
                <br />
                <br />
                Whenever possible, I also apply my passion for developing products
                with <b>Node.js</b> and{" "}
                <b>Modern Javascript Library and Frameworks</b> like{" "}
                <b>React Native, ReactJS, NextJS and Flutter</b>
                <br />
                <br />
                I am also <b>available for freelance projects on Upwork</b> — feel
                free to reach out for mobile or full-stack work.
              </p>
            </AnimatedSection>
          </Col>
          <Col md={4} className="myAvtar">
            <AnimatedSection direction="right" delay={0.2}>
              <Tilt tiltMaxAngleX={12} tiltMaxAngleY={12} scale={1.02}>
                <div className="avatar-wrapper">
                  <img src={myImg} className="img-fluid profile-photo" alt="Aftab Ali" />
                </div>
              </Tilt>
            </AnimatedSection>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <AnimatedSection>
              <h2>Find Me On</h2>
              <p>
                Feel free to <span className="purple">connect</span> with me
              </p>
              <ul className="home-about-social-links">
                {socialLinks.map((link, i) => (
                  <motion.li
                    key={link.href}
                    className="social-icons"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1, duration: 0.4 }}
                    whileHover={{ y: -4 }}
                  >
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour home-social-icons"
                    >
                      {link.icon}
                    </a>
                  </motion.li>
                ))}
              </ul>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
